module.exports = __webpack_public_path__ + "static/media/silkycloud-gold-2.2c6b8e5a.png";